import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useAnalytics } from '@lusha-engage/analytics';
import { Button } from '@lusha-ui/button';
import { GridContainer, GridItemExpand } from '@lusha-ui/core';
import { TextField } from '@lusha-ui/input';
import { Text } from '@lusha-ui/text';
import React, { useState } from 'react';
import { useAsyncFetch, useAsyncHandler } from 'react-hooks-async-handlers';
import FeedbackSvg from '../assets/feedback.svg';
const MAX_SIZE = 500;
function LeaveFeedbackView(props) {
    const { onSubmit, onSkip } = props;
    const [message, setMessage] = useState('');
    const analytics = useAnalytics();
    useAsyncFetch(() => __awaiter(this, void 0, void 0, function* () {
        analytics.track({
            eventType: 'feedback_rating_feedback_form_displayed',
        });
    }));
    const actionSubmit = useAsyncHandler(() => __awaiter(this, void 0, void 0, function* () {
        const feedback = yield onSubmit(message);
        analytics.track({
            eventType: 'feedback_rating_feedback_form_completed',
            event_external_key: feedback === null || feedback === void 0 ? void 0 : feedback.id,
            event_additional_info: {
                feedback_text: message,
            },
        });
    }));
    function handleSubmit() {
        actionSubmit.execute();
    }
    function handleSkip() {
        onSkip();
    }
    function handleChangeMessage(msg) {
        if (msg.length > MAX_SIZE) {
            msg = msg.slice(0, MAX_SIZE);
        }
        setMessage(msg);
    }
    return (_jsxs("div", { css: css `
        margin: 0 -8px;
      `, children: [_jsxs(GridContainer, { alignItems: 'center', children: [_jsx("div", { children: _jsx(GridContainer, { justifyContent: 'center', alignItems: 'center', css: css `
              width: 36px;
              height: 36px;
              border-radius: 50%;
              background-color: #f3f4f6;
            `, children: _jsx(FeedbackSvg, {}) }) }), _jsxs(GridItemExpand, { css: css `
            padding-left: 12px;
          `, children: [_jsx(Text, { variant: 'large20B', display: 'block', children: "Help us improve Lusha" }), _jsx(Text, { variant: 'small14R', display: 'block', children: "Share your feedback below" })] })] }), _jsxs("div", { css: css `
          margin-top: 24px;
        `, children: [_jsx(Text, { variant: 'tiny12R', children: "What should we improve?" }), _jsx(TextField, { name: 'message', value: message, multiline: true, placeholder: 'Tell us about your experience...', onChangeText: handleChangeMessage, css: css `
            textarea {
              min-height: 93px;
            }
          ` }), _jsx(GridContainer, { justifyContent: 'flex-end', css: css `
            margin-top: 6px;
          `, children: _jsxs(Text, { variant: 'tiny12R', children: [message.length, "/", MAX_SIZE] }) })] }), _jsxs("div", { css: css `
          margin-top: 24px;
          padding: 0 29px;
        `, children: [_jsx(Button, { variant: 'primary', size: 'small', onClick: handleSubmit, width: '100%', loading: actionSubmit.isLoading, css: css `
            margin-bottom: 8px;
          `, children: "Submit" }), _jsx(Button, { variant: 'secondaryGhost', size: 'small', onClick: handleSkip, width: '100%', children: "Skip" })] })] }));
}
export default LeaveFeedbackView;
